<template>
  <div class="company-basic">
    <div class="tab-swiper swiper-list-content" v-if="companyInfo && companyInfo.introduction">
      <section class="card-content-item">
        <h2 class="card-item-title">
          <i class="iconfont icon-qiye"></i>基本信息
        </h2>
        <div class="card-item-content">
          <div class="item-content" v-html="companyInfo.introduction"></div>
        </div>
      </section>
      <section class="card-content-item" v-for="(item,key) in brand_p" :key="key" :id="key">
        <div v-if="item.title && item.list && item.list.length > 0">
          <h2 class="card-item-title">
            <i class="iconfont" :class="item.icon"></i>
            {{item.title}}
          </h2>
          <div class="card-item-content" v-if="item.list">
            <div class="item-content" v-if="item.type ==='address'">
              <van-image
                width="100%"
                height="1.4rem"
                v-if="!hideAddress"
                :src="addressUrl"
                @error="hideAddress=true"
              />
              <p style="margin-top: 10px;">{{companyInfo.address}}</p>
            </div>
            <div class="item-content" v-if="item.type === 'string'" v-html="item.list"></div>
            <div class="item-content" v-for="(obj,li) in item.list" :key="li">
              <div v-if="item.type ==='array' && li < 6">
                <img :src="obj.img || obj.url" v-if="key!=='videos'" style="border-radius: 10px;" />
                <div class="video-wrap" v-else v-html="obj.url"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <no-data v-else></no-data>
  </div>
</template>

<script>
import NoData from "@/components/NoData";

export default {
  name: "company-basic",
  components: { NoData },
  props: {
    companyInfo: {
      type: Object
    },
    brandInfo: {
      type: Object
    }
  },
  computed: {
    brand_p() {
      let _self = this;
      let brand_p = {
        address: {
          title: "所在地址",
          icon: "icon-gsi-",
          list: _self.companyInfo.address,
          type: "address"
        },
        c_development: {
          title: "职业发展",
          icon: "icon-bangongbao",
          list: "",
          type: "string"
        },
        c_welfare: {
          title: "薪酬福利",
          icon: "icon-bangongbao",
          list: "",
          type: "string"
        },
        c_recruit: {
          title: "招聘流程",
          icon: "icon-bangongbao",
          list: "",
          type: "string"
        },
        videos: {
          title: "宣传视频",
          icon: "icon-shexiangtou",
          list: [],
          type: "array"
        },
        regions: {
          title: "办工环境",
          icon: "icon-bangongbao",
          list: [],
          type: "array"
        },
        schoolmates: {
          title: "员工风采",
          icon: "icon-dq-people",
          list: [],
          type: "array"
        }
      };
      if (_self.brandInfo) {
        for (let key in _self.brandInfo) {
          if (key.indexOf("c_") > -1 && _self.brandInfo[key]) {
            if (!brand_p[key]) brand_p[key] = [];
            let pattern = /<img/gi;
            brand_p[key].list = _self.brandInfo[key].replace(
              pattern,
              '<img class="rich-img" '
            );
          } else if (key === "regions") {
            if (_self.brandInfo[key].length > 0) {
              brand_p[key].list = JSON.parse(_self.brandInfo[key][0].img);
            }
          } else if (key === "videos") {
            if (_self.brandInfo[key]) {
              brand_p[key].list = [_self.brandInfo[key]];
            }
          } else if (key === "schoolmates") {
            brand_p[key].list = _self.brandInfo[key];
          }
        }
      }

      if (brand_p.regions.list.length > 0) {
        _self.$util.tansPics(brand_p.regions.list, "url", {});
      }
      if (brand_p.schoolmates.list.length > 0) {
        _self.$util.tansPics(brand_p.schoolmates.list, "img", {});
      }
      return brand_p;
    },
    addressUrl() {
      let that = this;
      const { address } = that.companyInfo;

      const url =
        "http://api.map.baidu.com/staticimage/v2?ak=xFXFMkIXXsPyzlt3ubUCwasP&mcode=666666&markers=" +
        address +
        "&center=" +
        address +
        "&height=140&zoom=13";

      return url;
    }
  },
  data() {
    return {
      hideAddress: false,
      loadAddressPic: 0
    };
  },
  mounted() {},
  methods: {
    bindNavgetion() {
      let _self = this;

      const { address, city_name } = _self.companyInfo;

      // var ak = "xFXFMkIXXsPyzlt3ubUCwasP";
      // var url = 'http://api.map.baidu.com/geocoding/v3/?address=' + address + '&ak=' + ak + '&output=json&coordtype=wgs84ll&city=' + city_name;

      _self.$util
        .get("kzp_video_jobfair", "geocoding", { address, city_name })
        .then(res => {
          const { code, data, msg } = res;

          let latitude, longitude;
          if (code === 1) {
            const { location } = data || {};
            try {
              latitude = location.lat;
              longitude = location.lng;
            } catch (error) {
              // 
            }
          }

          if (latitude && longitude) {
            _self.openLocation({
              latitude,
              longitude,
              address,
              scale: 3,
              infoUrl:
                "https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#111",
              name: "测试一下子"
            });
          } else {
            this.$dialog
              .alert({
                message: msg || "获取地址信息失败"
              })
              .then(() => {
                // on close
              });
          }
        });
    },
    openLocation(data) {
      let that = this;

      that.$util.jweixin(
        {
          url: location.href,
          token: that.$store.state.token
        },
        that.$wechat,
        function(wx) {
          that.$util.openLocation(wx, data);
        }
      );
    }
  }
};
</script>

<style lang="scss">
.card-content-item {
  img {
    min-width: 100%;
    min-height: 100%;
    max-width: 100%;
    max-height: none;
  }
}
</style>

<style lang="scss" scoped>
.company-basic {
  .card-content-item {
    margin-bottom: 35px;
    text-align: left;

    .card-item-title {
      font-size: 16px;
      line-height: 21px;

      .iconfont {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: $themeColor;
        margin-right: 0.05rem;
        color: #ffffff;
        text-align: center;
        font-size: 12px;
        vertical-align: 1px;
      }
    }

    .card-item-content {
      padding: 12px 0;
      font-size: 0;

      .item-content {
        font-size: 14px;
        color: #666666;
        margin-bottom: 5px;
      }
    }

    .regions-wrap,
    .schoolmates-wrap {
      .item-content {
        display: inline-block;
        width: 90px;
        height: 90px;
        margin: 0 calc((100% - 2.8rem) / 6);
        text-align: center;
        line-height: 90px;
        border: 1px solid #f3f3f3;
        border-radius: 0.1rem;
        overflow: hidden;
        font-size: 0;

        @media screen and (max-width: 370px) {
          & {
            width: 80px;
            height: 80px;
            margin: 0 calc((100% - 2.46rem) / 6);
            line-height: 80px;
          }
        }

        img {
          min-width: 100%;
          min-height: 100%;
          max-width: 100%;
          max-height: none;
        }
      }
    }
  }
}
</style>
